import clsx from "clsx";
import React from "react";

export type suggestionsType = {
	code: string;
	country?: string;
	disabled?: boolean;
	name: string;
	status_description?: string;
	type_code?: string;
	type_description?: string;
}[];

interface SuggestionsProps {
	active?: string;
	dropdownIsOpened: boolean;
	loading?: boolean;
	onSuggestionSelected: (code: string, name: string) => void;
	suggestions: suggestionsType;
	value: string;
}

export default function Suggestions({
	active,
	dropdownIsOpened,
	loading,
	onSuggestionSelected,
	suggestions,
	value,
}: SuggestionsProps) {
	if (value.length === 0 || suggestions.length === 0 || !dropdownIsOpened) {
		return null;
	}

	const options = suggestions.map((item) => {
		const {
			name,
			code,
			country,
			disabled = false,
			status_description,
			type_code,
			type_description,
		} = item;

		return (
			<li
				key={code}
				aria-selected="false"
				className={clsx("autosuggest__suggestion", {
					active: code === active,
				})}
			>
				<button
					type="button"
					id={code}
					disabled={disabled}
					onClick={() => onSuggestionSelected(code, name)}
				>
					<span>{name}</span>
					{country && <span>{country}</span>}
					{type_code && (
						<span title={type_description}>{type_code}</span>
					)}
					{status_description && <span>{status_description}</span>}
				</button>
			</li>
		);
	});

	return (
		<div
			className={clsx("autosuggest__suggestions-container", {
				"autosuggest__suggestions-container--scrollable":
					suggestions.length > 10,
			})}
		>
			{loading && (
				<div className="autosuggest__suggestions-loading loading">
					<div className="loader" />
				</div>
			)}
			{!loading && (
				<ul className="autosuggest__suggestions-list">{options}</ul>
			)}
		</div>
	);
}
